import { Sparkles } from "lucide-react";
import { MONTH_NAMES_PT } from "./constants";

// Monthly completion dashboard (per vínculo) shown under the practices grid.
export const DashboardPanel = ({ dashboard, month }) => (
  <div className="mt-10 bg-[hsl(var(--primary))] text-white p-6 lg:p-8" data-testid="spiritual-dashboard">
    <div className="overline text-[hsl(var(--accent))]"><Sparkles className="inline h-3 w-3 mr-1" /> Cumprimento — {MONTH_NAMES_PT[month - 1]}</div>
    <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {(dashboard?.by_vinculo || []).map((d) => {
        const pct = Math.round((d.completion || 0) * 100);
        return (
          <div key={d.key} className="border border-white/15 p-4" data-testid={`dash-${d.key}`}>
            <div className="text-[10px] uppercase tracking-[0.18em] text-white/70">{d.label}</div>
            <div className="mt-2 text-3xl tabular-nums">{pct}%</div>
            <div className="text-[11px] text-white/60 mt-1">{d.done_days} de {d.marked_days} previstos</div>
            <div className="mt-3 h-1 bg-white/15">
              <div className="h-1 bg-[hsl(var(--accent))]" style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
